import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import ProtectedRoute from '../components/ProtectedRoute';

/**
 * Subscription Plans Page Component
 */
const Subscription = () => {
  const { isAuthenticated } = useAuth();
  const { plans, purchaseSubscription, isSubscribed } = useSubscription();
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handlePurchase = (planId) => {
    if (!isAuthenticated()) {
      navigate('/login');
      return;
    }

    const result = purchaseSubscription(planId);
    setMessage(result.message || 'Subscription activated successfully!');
    
    setTimeout(() => {
      setMessage('');
      if (result.success) {
        navigate('/profile');
      }
    }, 3000);
  };

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        💎 Subscription Plans
      </h1>

      {message && (
        <div className="card" style={{ 
          background: 'var(--highlight-color)', 
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          {message}
        </div>
      )}

      <div className="grid">
        {plans.map(plan => (
          <div key={plan.id} className="card" style={{ 
            border: isSubscribed() && plan.id === 'premium' ? '3px solid var(--highlight-color)' : 'none',
            position: 'relative'
          }}>
            {isSubscribed() && plan.id === 'premium' && (
              <div style={{ 
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'var(--highlight-color)',
                padding: '5px 10px',
                borderRadius: '5px',
                fontSize: '12px'
              }}>
                CURRENT PLAN
              </div>
            )}

            <h2 style={{ fontSize: '28px', color: 'var(--highlight-color)', marginBottom: '10px' }}>
              {plan.name}
            </h2>
            
            <div style={{ fontSize: '36px', marginBottom: '20px' }}>
              <strong>${plan.price}</strong>
              {plan.price > 0 && <span style={{ fontSize: '18px', color: 'var(--text-dark)' }}>/month</span>}
            </div>

            <ul style={{ listStyle: 'none', padding: 0, marginBottom: '30px' }}>
              {plan.features.map((feature, index) => (
                <li key={index} style={{ 
                  padding: '10px 0',
                  borderBottom: '1px solid var(--card-hover)',
                  color: 'var(--text-dark)'
                }}>
                  ✓ {feature}
                </li>
              ))}
            </ul>

            {isSubscribed() && plan.id === 'premium' ? (
              <button className="btn btn-secondary" disabled style={{ width: '100%' }}>
                Current Plan
              </button>
            ) : plan.id === 'free' ? (
              <button 
                onClick={() => handlePurchase(plan.id)}
                className="btn btn-secondary" 
                style={{ width: '100%' }}
              >
                Select Free
              </button>
            ) : (
              <button 
                onClick={() => handlePurchase(plan.id)}
                className="btn btn-primary" 
                style={{ width: '100%' }}
              >
                Subscribe Now
              </button>
            )}
          </div>
        ))}
      </div>

      <div className="card" style={{ marginTop: '30px', textAlign: 'center' }}>
        <h3 style={{ marginBottom: '15px' }}>Premium Features Include:</h3>
        <p style={{ color: 'var(--text-dark)', marginBottom: '10px' }}>
          • Post and share articles with the community
        </p>
        <p style={{ color: 'var(--text-dark)', marginBottom: '10px' }}>
          • Access real-time chat rooms for launches
        </p>
        <p style={{ color: 'var(--text-dark)', marginBottom: '10px' }}>
          • Advanced launch trajectory projections
        </p>
        <p style={{ color: 'var(--text-dark)' }}>
          • Save favorites and personalize your experience
        </p>
      </div>

      {!isAuthenticated() && (
        <div className="card" style={{ marginTop: '30px', textAlign: 'center', background: 'var(--card-hover)' }}>
          <p style={{ marginBottom: '15px' }}>
            Please <a href="/login" style={{ color: 'var(--highlight-color)' }}>login</a> or <a href="/register" style={{ color: 'var(--highlight-color)' }}>register</a> to subscribe.
          </p>
        </div>
      )}
    </div>
  );
};

export default Subscription;
